const AppSetting = {
    MarketReport: process.env.VUE_APP_BACK_URL_ENV + "Report/MarketReport",
    MarkLockedReport: process.env.VUE_APP_BACK_URL_ENV + "Report/MarkLockedReport",
    UnLockedReport: process.env.VUE_APP_BACK_URL_ENV + "Report/UnLockedReport",
    GetOldReports: process.env.VUE_APP_BACK_URL_ENV + "Report/GetReports",
    GetReports: process.env.VUE_APP_BACK_URL_ENV + "Report/GetReportHistoryWithPaging",
    GetSampleReports: process.env.VUE_APP_BACK_URL_ENV + "Report/GetSampleReports",
    GetSampleReport: process.env.VUE_APP_BACK_URL_ENV + "Report/GetSampleReport",
    //DownloadReportScreen: process.env.VUE_APP_BACK_URL_ENV + "Report/DownloadReportScreenshot",
    DownloadReportPDF: process.env.VUE_APP_BACK_URL_ENV + "Report/DownloadReportPDF",
    GenerateReportAnalysisSummary: process.env.VUE_APP_BACK_URL_ENV + "AIReport/GenerateReportAnalysisSummary",
    CheckReportAnalysisSummaryTaskStatus: process.env.VUE_APP_BACK_URL_ENV + "AIReport/CheckReportAnalysisSummaryTaskStatus",

    GetIndustryList: process.env.VUE_APP_BACK_URL_ENV + "Industry/GetList",

    SearchAddress: process.env.VUE_APP_BACK_URL_ENV + "Map/SearchAddress",
    GetAdl: process.env.VUE_APP_BACK_URL_ENV + "Map/GetAdl",

    LoginDb: process.env.VUE_APP_BACK_URL_ENV + "Account/Login",
    RegisterDb: process.env.VUE_APP_BACK_URL_ENV + "Account/Register",
    RegisterTerms: process.env.VUE_APP_BACK_URL_ENV + "Account/GetRegisterTerms",
    ReSendMailDb: process.env.VUE_APP_BACK_URL_ENV + "Account/ReSendMail",
    ValidToken: process.env.VUE_APP_BACK_URL_ENV + "Account/ValidToken",

    MyInfo: process.env.VUE_APP_BACK_URL_ENV + "Account/MyInfo",
    UpdateMyInfo: process.env.VUE_APP_BACK_URL_ENV + "Account/UpdateMyInfo",

    AddToCar: process.env.VUE_APP_BACK_URL_ENV + "Billing/Buy",
    GetLicenseSeatCount: process.env.VUE_APP_BACK_URL_ENV + "Billing/GetLicenseSeats",
    GetBilling: process.env.VUE_APP_BACK_URL_ENV + "Billing/GetBillingHistoryWithPaging",
    GetProducts: process.env.VUE_APP_BACK_URL_ENV + "Billing/GetAllProducts",

    Feedback: process.env.VUE_APP_BACK_URL_ENV + "Feedback/SendFeedback",

    AddVoucher: process.env.VUE_APP_BACK_URL_ENV + "Voucher/AddVoucher",
    GetVoucherList: process.env.VUE_APP_BACK_URL_ENV + "Voucher/GetVoucherWithPaging",
    GetVoucherDetailList: process.env.VUE_APP_BACK_URL_ENV + "Voucher/GetVoucherDetailWithPaging",
    VoucherList: process.env.VUE_APP_BACK_URL_ENV + "Voucher/VoucherList",
    GetRedeemCodeTerms: process.env.VUE_APP_BACK_URL_ENV + "Voucher/GetRedeemCodeTerms",
    GetAdList: process.env.VUE_APP_BACK_URL_ENV + "Advertisement/GetAd",

    MySurveycake: process.env.VUE_APP_SURVERYCAKE_URL,

    GetAudience: process.env.VUE_APP_BACK_URL_ENV + "Account/GetAudienceInfo",
    UpdateAudience: process.env.VUE_APP_BACK_URL_ENV + "Account/UpdateAudienceInfo",

    GetCompetitorList: process.env.VUE_APP_BACK_URL_ENV + "ManualReport/UserBrandsList",
    GetAdl2List: process.env.VUE_APP_BACK_URL_ENV + "ManualReport/GetAdl2List",
    GetAdl5List: process.env.VUE_APP_BACK_URL_ENV + "ManualReport/GetAdl5List",

    PerPage: "10",
    Online: process.env.VUE_APP_ONLINE,

    IsSysMaintain: "false",
    SysMaintainDatetime: "2020.07.13(一) 9:00 ~ 18:00 ",

    DropDownList: {
        PriceList: [{ label: '小於 150 元', value: 150 }, { label: '150 - 300 元', value: 300 }, { label: '300 - 500 元', value: 500 }, { label: '500 - 1,000 元', value: 1000 }, { label: '1,000 - 3,000 元', value: 3000 }, { label: '大於 3,000 元', value: 10000 }],
        RadiusList: [{ label: '250m', value: 250 }, { label: '500m', value: 500 }, { label: '1km', value: 1000 }, { label: '2km', value: 2000 }, { label: '3km', value: 3000 }, { label: '4km', value: 4000 }, { label: '5km', value: 5000 }],
    },

    AdvancedReportChannelID: "B27C60DF-6123-4807-B81E-FC0447010C65",

    ServiceRadiusList: {
        "北區": {
            "早餐店": {
                "都會區": "250m - 500m",
                "非都會區": "500m - 2km"
            },
            "速食店": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            },
            "炸物小吃": {
                "都會區": "250m - 500m",
                "非都會區": "500m - 2km"
            },
            "手搖飲料": {
                "都會區": "250m - 500m",
                "非都會區": "500m - 2km"
            },
            "平價小吃": {
                "都會區": "250m - 500m",
                "非都會區": "500m - 2km"
            },
            "咖啡店": {
                "都會區": "250m - 500m",
                "非都會區": "500m - 2km"
            },
            "火鍋": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            },
            "燒烤": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            },
            "平價火鍋": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            },
            "披薩店": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "餐酒館": {
                "都會區": "500m",
                "非都會區": "2km - 3km"
            },
            "麵包店": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            },
            "美髮院": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            },
            "健身房": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "便利商店": {
                "都會區": "250m - 500m",
                "非都會區": "500m - 1km"
            },
            "寵物用品": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "洗衣店": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            },
            "藥局": {
                "都會區": "500m",
                "非都會區": "500m - 2km"
            }
        },
        "中區": {
            "早餐店": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "速食店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "炸物小吃": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "手搖飲料": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "平價小吃": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "咖啡店": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "火鍋": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "燒烤": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "平價火鍋": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 2km"
            },
            "披薩店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "餐酒館": {
                "都會區": "500m - 1km",
                "非都會區": "2km - 5km"
            },
            "麵包店": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "美髮院": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "健身房": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "便利商店": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "寵物用品": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "洗衣店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 2km"
            },
            "藥局": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            }
        },
        "南區": {
            "早餐店": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "速食店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "炸物小吃": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "手搖飲料": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "平價小吃": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "咖啡店": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "火鍋": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "燒烤": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "平價火鍋": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 2km"
            },
            "披薩店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "餐酒館": {
                "都會區": "500m - 1km",
                "非都會區": "2km - 5km"
            },
            "麵包店": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "美髮院": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "健身房": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "便利商店": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            },
            "寵物用品": {
                "都會區": "500m",
                "非都會區": "1km - 3km"
            },
            "洗衣店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 2km"
            },
            "藥局": {
                "都會區": "500m",
                "非都會區": "1km - 2km"
            }
        },
        "東區": {
            "早餐店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "速食店": {
                "都會區": "1km - 2km",
                "非都會區": "1km - 3km"
            },
            "炸物小吃": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "手搖飲料": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "平價小吃": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "咖啡店": {
                "都會區": "1km - 2km",
                "非都會區": "1km - 3km"
            },
            "火鍋": {
                "都會區": "500m - 1km",
                "非都會區": "2km - 5km"
            },
            "燒烤": {
                "都會區": "500m - 1km",
                "非都會區": "2km - 5km"
            },
            "平價火鍋": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "披薩店": {
                "都會區": "500m - 1km",
                "非都會區": "2km - 5km"
            },
            "餐酒館": {
                "都會區": "1km - 2km",
                "非都會區": "2km - 5km"
            },
            "麵包店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "美髮院": {
                "都會區": "1km - 2km",
                "非都會區": "1km - 3km"
            },
            "健身房": {
                "都會區": "1km - 2km",
                "非都會區": "1km - 3km"
            },
            "便利商店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "寵物用品": {
                "都會區": "500m - 1km",
                "非都會區": "2km - 5km"
            },
            "洗衣店": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            },
            "藥局": {
                "都會區": "500m - 1km",
                "非都會區": "1km - 3km"
            }
        }
    }
};

export default AppSetting;